import * as React from "react";
import { notification } from "antd";
import { Outlet, useNavigate } from "react-router";
import { useQueryClient } from "@tanstack/react-query";

import useLoadUser from "../../services/auth/useLoadUser";
import {
  getRefreshToken,
  removeAccessToken,
  removeRefreshToken,
} from "../../utils/auth";

export default function Root() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [isNotificationOpen, setIsNotificationOpen] = React.useState(false);

  const {
    isLoading: authLoading,
    fetchStatus: authFetchStatus,
    refetch: authRefetch,
    data: authData,
  } = useLoadUser();

  const authLogout = async () => {
    try {
      queryClient.clear();
      navigate("/");
      getRefreshToken();
      removeAccessToken();
      removeRefreshToken();

      notification.success({
        message: "You are logged out",
      });
    } catch (error) {
      return;
    }
  };

  const openNotification = () =>
    !isNotificationOpen ? setIsNotificationOpen(true) : null;

  const closeNotification = () =>
    isNotificationOpen ? setIsNotificationOpen(false) : null;

  return (
    <Outlet
      context={{
        authLoading,
        authFetchStatus,
        authRefetch,
        authData,
        authLogout,
        openNotification,
        closeNotification,
        isNotificationOpen,
      }}
    />
  );
}
